import {
  Component,
  Input,
  forwardRef,
  Injector,
  AfterViewInit
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl,
  UntypedFormControl
} from '@angular/forms';
import { DAYS, MONTHS } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimeComponent),
      multi: true
    }
  ]
})
export class DateTimeComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label: string;
  @Input() caption: string;
  @Input() placeholder: string;
  @Input() _internalValue = '';
  @Input() displayFormat = 'MM/DD/YY';
  @Input() maxDate: string;
  @Input() error: string;

  dayNames = DAYS.map(day => day.code);
  monthNames = MONTHS.map(month => month.code);

  touched = false;

  control: UntypedFormControl;

  onChange = (_: any) => {};
  onTouched = (_: any) => {};

  get internalValue() {
    return this._internalValue;
  }

  set internalValue(val: any) {
    if (val === undefined || val === null || val === '') {
      this._internalValue = '';
      this.onChange(undefined); // Value is rubbish, so don't send back to model propper
      return;
    }

    this._internalValue = val;
    this.onChange(this._internalValue); // Value is good!
  }

  constructor(private injector: Injector) {}

  ngAfterViewInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as UntypedFormControl;
    }
  }

  //////////////////////////////////
  // ControlValueAccessor interface
  //////////////////////////////////

  writeValue(value: any) {
    if (value === undefined || value === null) {
      this.internalValue = '';
      return;
    }

    this.internalValue = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    const self = this;
    this.onTouched = (arg: any) => {
      self.touched = true;
      fn(arg);
    };
  }
}
